import {RTCManager} from "@alphabatem/js_sdk/src/managers/rtc_manager.js";

export class ThreeRTCManager extends RTCManager {

	videoToggle;
	audioToggle;
	audioToggleIcon;

	constructor() {
		super(""); //We set room later on through joinRoom
	}

	joinRoomWithPermissions(roomID, videoEnabled, audioEnabled) {
		this.setPermissions(videoEnabled, audioEnabled)
		this.setRoom(roomID)
		return this.join()
	}


	join() {
		console.log("ThreeRTCManager::join", this.roomID)
		this.setupEventListeners()
		return super.join()
	}

	setupEventListeners() {
		this.clearEventListeners()

		this.meetingTools = document.getElementById("meeting-tools")
		this.leaveToggle = document.getElementById("meeting-leave-toggle")
		this.videoToggle = document.getElementById("video-mute-toggle")
		this.audioToggle = document.getElementById("audio-mute-toggle")
		this.audioToggleIcon = document.getElementById("audio-mute-toggle-icon")

		this.audioToggle.addEventListener("click", this.muteMic.bind(this));
		this.videoToggle.addEventListener("click", this.muteCam.bind(this));
		this.leaveToggle.addEventListener("click", this.leaveMeeting.bind(this));
	}

	clearEventListeners() {
		if (this.audioToggle)
		this.audioToggle.removeEventListener("click", this.muteMic.bind(this));
		if (this.videoToggle)
		this.videoToggle.removeEventListener("click", this.muteCam.bind(this));
		if (this.leaveToggle)
		this.leaveToggle.removeEventListener("click", this.leaveMeeting.bind(this));
	}

	/**
	 * @override RTCManager.onPeerTrack
	 * @param e
	 */
	onPeerTrack(e) {
		console.log("onPeerTrack", e)
		if (e.track.kind === 'audio') {
			return
		}

		console.log("Adding peer track", e)
		let el = document.createElement(e.track.kind)
		el.srcObject = e.streams[0]
		el.autoplay = true
		el.controls = true
		el.playsInline = true
		el.width = 240
		// el.height = 180
		// width="160" height="120"

		const container = document.createElement("div")
		container.classList.add("col")
		container.classList.add("px-0")
		container.appendChild(el)

		document.getElementById('remoteVideos').appendChild(container)

		e.track.onmute = function (event) {
			el.play()
		}

		e.streams[0].onremovetrack = ({track}) => {
			console.log("removing track")
			if (el.parentNode) {
				el.parentNode.removeChild(el)
			}
		}
	}

	onStreamReceived(stream) {
		super.onStreamReceived(stream)
		document.getElementById('localVideo').srcObject = this.stream

		if (!this.isMuted.audio)
			this.audioToggle.classList.toggle("active")
		else
			this.audioToggleIcon.classList.toggle("visible")

		if (!this.isMuted.video)
			this.videoToggle.classList.toggle("active")
	}

	muteCam() {
		super.muteCam()

		const localVideo = document.getElementById('localVideo')
		if (!localVideo) {
			console.error("Unable to mute video, missing camera elem")
			return
		}

		if (this.isMuted.video) {
			localVideo.srcObject = null
		} else {
			localVideo.srcObject = this.stream
		}

		document.getElementById("video-local-container").classList.toggle("active", !this.isMuted.video)
		this.videoToggle.classList.toggle("active")
	}

	muteMic() {
		super.muteMic()
		this.audioToggle.classList.toggle("active")
		this.audioToggleIcon.classList.toggle("visible")
	}

	leaveMeeting() {
		this.reset()
	}

	onOpen(e) {
		super.onOpen(e);
		document.getElementById("video-local-container").classList.toggle("active", !this.isMuted.video)
	}

	onClose(e) {
		console.log("RTC::onClose")
		if (this.stream != null) {
			this.stream.getTracks().forEach(track => {
				console.log("Removing local track", track)
				track.stop()
			})
			this.stream = null
		}

		if (this.pc != null) {
			this.pc.close()
			this.pc = null
		}

		if (this.ws != null) {
			this.ws.close()
			this.ws = null
		}

		this.clearEventListeners();

		if (document.getElementById('remoteVideos') != null) {
			document.getElementById('remoteVideos').innerHTML = ""
		}

		if (document.getElementById("video-local-container") != null) {
			document.getElementById("video-local-container").classList.toggle("active", false)
		}

		if (document.getElementById('localVideo') != null) {
			document.getElementById('localVideo').srcObject = null
			document.getElementById('localVideo').src = null
		}
		super.onClose(e)
	}

	onError(e) {
		super.onError(e)
		this.clearEventListeners();
	}
	
	reset() {
		console.log("RTC Reset")
		super.reset()
	}
}